import productsAPI from '@/api/productsAPI'

const state = {
  loadedProduct: {},
  isSaving: false,
  isExportingPdf: false
}

const getters = {
  loadedProduct (state) {
    return state.loadedProduct
  },
  isSaving (state) {
    return state.isSaving
  },
  isExportingPdf (state) {
    return state.isExportingPdf
  }
}

const actions = {
  view ({ commit }, productId) {
    commit('setLoading', true, { root: true })
    productsAPI.view(productId)
      .then(resp => {
        commit('setLoading', false, { root: true })
        commit('setLoadedProduct', resp.data.product)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
      })
  },
  unlock ({ commit, dispatch }, productId) {
    commit('setLoading', true, { root: true })
    productsAPI.unlock(productId)
      .then(resp => {
        commit('setLoading', false, { root: true })
        commit('setUnlocked', true)
        dispatch('view', productId)
      })
      .catch(error => {
        commit('setLoading', false, { root: true })
        commit('setError', error, { root: true })
      })
  },
  save ({ commit }) {
    commit('setSaving', true)
    productsAPI.save(state.loadedProduct)
      .then(resp => {
        commit('setSaving', false)
        commit('setLoadedProduct', resp.data.product)
      })
      .catch(error => {
        commit('setSaving', false)
        commit('setError', error, { root: true })
      })
  },
  exportPDF ({ commit }) {
    commit('setExportingPdf', true)
    var that = this
    productsAPI.exportPDF(state.loadedProduct)
      .then(resp => {
        commit('setExportingPdf', false)
        var date = new Date()
        var filename = that.state.products.loadedProduct.name.replace(/\s+/g, '-').toLowerCase()
        const year = date.getFullYear()
        const month = (1 + date.getMonth()).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const hour = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        const seconds = date.getSeconds().toString().padStart(2, '0')
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp)
        link.download = `${filename}-${year}-${month}-${day}-${hour}${minutes}${seconds}.pdf`
        link.click()
      })
      .catch(error => {
        commit('setExportingPdf', false)
        commit('setError', error, { root: true })
      })
  }
}

const mutations = {
  setSaving (state, payload) {
    state.isSaving = payload
  },
  setExportingPdf (state, payload) {
    state.isExportingPdf = payload
  },
  setLoadedProduct (state, payload) {
    state.loadedProduct = payload
  },
  setUnlocked (state, payload) {
    state.loadedProduct.unlocked = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
